// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.FadeScrollWrapper {
  flex: 1 1;
  min-height: 0;
  position: relative;
  overflow-y: auto;
}
@media only screen and (min-width: 600px) {
  .FadeScrollWrapper::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  .FadeScrollWrapper::-webkit-scrollbar-track {
    background: transparent;
  }
  .FadeScrollWrapper::-webkit-scrollbar-thumb {
    background: var(--color_neutral_200);
    height: 80px;
    border-radius: 50px;
  }
  .FadeScrollWrapper:hover::-webkit-scrollbar-thumb {
    background: var(--color_neutral_400);
  }
  .FadeScrollWrapper::-webkit-scrollbar-thumb:active {
    background: var(--color_neutral_500);
  }
}
.FadeScrollWrapper .FadeScrollWrapper-shadow-top {
  pointer-events: none;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  width: 100%;
  height: 30px;
  margin-bottom: -29px;
  background: linear-gradient(to top, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);
  transition: opacity 0.16s;
  z-index: 1;
  transform: translateY(-2px);
}
.FadeScrollWrapper .FadeScrollWrapper-shadow-bottom {
  pointer-events: none;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  width: 100%;
  height: 30px;
  margin-top: -29px;
  background: linear-gradient(to bottom, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);
  transition: opacity 0.16s;
  z-index: 1;
  transform: translateY(2px);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/FadeScrollWrapper/styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAeF;AAbE;EDMA;IACE,UAAA;IACA,WAAA;ECUF;EDPA;IACE,uBAAA;ECSF;EDNA;IACE,oCAdM;IAeN,YAAA;IACA,mBAAA;ECQF;EDJE;IACE,oCApBS;EC0Bb;EDFA;IACE,oCAxBY;EC4Bd;AACF;AA7BE;EACE,oBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0FAAA;EACA,yBAAA;EACA,UAAA;EACA,2BAAA;AA+BJ;AA5BE;EACE,oBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6FAAA;EACA,yBAAA;EACA,UAAA;EACA,0BAAA;AA8BJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.FadeScrollWrapper {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow-y: auto;\n\n  @media only screen and (min-width: 600px) {\n    @include scrollbar();\n  }\n\n  .FadeScrollWrapper-shadow-top {\n    pointer-events: none;\n    position: sticky;\n    top: 0;\n    width: 100%;\n    height: 30px;\n    margin-bottom: -29px;\n    background: linear-gradient(to top, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);\n    transition: opacity 0.16s;\n    z-index: 1;\n    transform: translateY(-2px);\n  }\n  \n  .FadeScrollWrapper-shadow-bottom {\n    pointer-events: none;\n    position: sticky;\n    bottom: 0;\n    width: 100%;\n    height: 30px;\n    margin-top: -29px;\n    background: linear-gradient(to bottom, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);\n    transition: opacity 0.16s;\n    z-index: 1;\n    transform: translateY(2px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
